import { render, staticRenderFns } from "./QuoteImages.vue?vue&type=template&id=1ae1e9b7"
import script from "./QuoteImages.vue?vue&type=script&lang=js"
export * from "./QuoteImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ae1e9b7')) {
      api.createRecord('1ae1e9b7', component.options)
    } else {
      api.reload('1ae1e9b7', component.options)
    }
    module.hot.accept("./QuoteImages.vue?vue&type=template&id=1ae1e9b7", function () {
      api.rerender('1ae1e9b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/QuoteImages.vue"
export default component.exports